/**
 * @flow
 * @relayHash f84d7085a20648ad3f66b64caca745ea
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type CheckoutAutoModalMutationVariables = {|
  input: {
    action: "ADD" | "EDIT" | "REMOVE" | "REORDER";
    endPortfolioItemId?: ?string;
    itemsIds?: ?$ReadOnlyArray<?string>;
    note?: ?string;
    portfolioItemsIds?: ?$ReadOnlyArray<?string>;
    portfolioId?: ?string;
    portfolioType?: ?"HEART" | "CART";
    startPortfolioItemId?: ?string;
    targetPortfolioItemId?: ?string;
    userId: string;
    clientMutationId?: ?string;
  };
|};

export type CheckoutAutoModalMutationResponse = {|
  +modifyPortfolioItems: ?{|
    +clientMutationId: ?string;
  |};
|};
*/


/*
mutation CheckoutAutoModalMutation(
  $input: ModifyPortfolioItemsInput!
) {
  modifyPortfolioItems(input: $input) {
    clientMutationId
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "ModifyPortfolioItemsInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CheckoutAutoModalMutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "ModifyPortfolioItemsInput!"
          }
        ],
        "concreteType": "ModifyPortfolioItemsPayload",
        "name": "modifyPortfolioItems",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "clientMutationId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "CheckoutAutoModalMutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "ModifyPortfolioItemsInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "CheckoutAutoModalMutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "ModifyPortfolioItemsInput!"
          }
        ],
        "concreteType": "ModifyPortfolioItemsPayload",
        "name": "modifyPortfolioItems",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "clientMutationId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "mutation CheckoutAutoModalMutation(\n  $input: ModifyPortfolioItemsInput!\n) {\n  modifyPortfolioItems(input: $input) {\n    clientMutationId\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/abandonedCheckout/components/__generated__/CheckoutAutoModalMutation.graphql.js